// Centralized API configuration for frontend
// Automatically switches between localhost (dev) and Render (production)

export const API_HOST = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// Helper to build full API URLs
export const getApiUrl = (endpoint) => {
  return `${API_HOST}${endpoint.startsWith('/') ? endpoint : '/' + endpoint}`;
};
